// extracted by mini-css-extract-plugin
module.exports = {"marketplacePaginationContainer":"the-edit_marketplacePaginationContainer__xe566"};